import React from 'react';
import queryString from 'query-string';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import { useProgressContext } from '@/contexts/useProgressContext';
import useCopyToClipboard from '@/hooks/useCopyToClipboard';

import Alert from '@/components/Alert';

import preOrderAPI from '@/api/preOrder';

import Header from '@/containers/Layout/Header';
import WatchedGroupPreOrderCard from './WatchedGroupPreOrderCard';

const COPIED_ALERT = 'COPIED_ALERT';

const sanitizeWatchedGroupPreOrder = (remoteData) => {
  const now = new Date().getTime();
  const watchedGroupPreOrderDic = JSON.parse(localStorage.getItem('watchedGroupPreOrder')) || {};
  Object.keys(watchedGroupPreOrderDic).forEach((groupPreOrderId) => {
    const groupPreOrder = remoteData[groupPreOrderId];
    if (!groupPreOrder) {
      delete watchedGroupPreOrderDic[groupPreOrderId];
    } else if (groupPreOrder.registerEndTime < now) {
      delete watchedGroupPreOrderDic[groupPreOrderId];
    }
  });
  localStorage.setItem('watchedGroupPreOrder', JSON.stringify(watchedGroupPreOrderDic));
};

const WatchedGroupPreOrderList = () => {
  const {
    start: startProgress,
    end: endProgress,
  } = useProgressContext();
  const { handleCopy } = useCopyToClipboard();
  const [watchedGroupPerOrderDic, setWatchedGroupPreOrderDic] = React.useState({});
  const [activeAlert, setActiveAlert] = React.useState(null);

  const handleCopyToSharePreOrder = React.useCallback(({
    preOrderId,
    promotionCode,
  }) => {
    handleCopy(`${window.location.origin}/pre-orders/${preOrderId}?${queryString.stringify({
      promotionCode,
    })}`);
    setActiveAlert(COPIED_ALERT);
  }, [handleCopy]);

  React.useEffect(() => {
    const list = JSON.parse(localStorage.getItem('watchedGroupPreOrder')) || {};

    startProgress();
    preOrderAPI.getWatchedPreOrderList({
      query: {
        groupPreOrderIds: Object.keys(list).join(','),
      },
    }).then(({ status, watchedGroupPreOrders: watchedGroupPreOrdersData }) => {
      if (status !== 'OK') return;
      setWatchedGroupPreOrderDic(watchedGroupPreOrdersData);
      sanitizeWatchedGroupPreOrder(watchedGroupPreOrdersData);
    }).finally(() => {
      endProgress();
    });
  }, []); // eslint-disable-line

  return (
    <>
      <Header />
      <Box mx={1}>

        <Box py={0.5}>
          <Divider />
        </Box>
        <Box
          fontSize="subtitle1.fontSize"
          fontWeight="fontWeightBold"
          textAlign="center"
        >
          關注中的團購
        </Box>
        <Box pt={0.5}>
          <Divider />
        </Box>
        <Box>
          <Grid container>
            {
              Object.keys(watchedGroupPerOrderDic)
                .sort((k1, k2) => {
                  const t1 = watchedGroupPerOrderDic[k1]?.registerEndTime || 0;
                  const t2 = watchedGroupPerOrderDic[k2]?.registerEndTime || 0;
                  return t1 - t2;
                })
                .map((groupPreOrderId) => {
                  const data = watchedGroupPerOrderDic[groupPreOrderId];
                  return (
                    <Grid item key={groupPreOrderId} xs={12}>
                      <WatchedGroupPreOrderCard
                        data={data}
                        hanldeShare={handleCopyToSharePreOrder}
                      />
                    </Grid>
                  );
                })
            }
          </Grid>
        </Box>
        <Alert
          isOpen={activeAlert === COPIED_ALERT}
          title="分享網址複製成功"
          content="現在立刻打開對話視窗，將網址貼上通知好友！"
          buttons={(
            <Button fullWidth onClick={() => setActiveAlert(null)}>
              <Box fontWeight="fontWeightBold" color="support.main">
                確認
              </Box>
            </Button>
          )}
        />
      </Box>
    </>
  );
};

export default WatchedGroupPreOrderList;
